import { render } from "./GuidedScreener.vue?vue&type=template&id=20bc8ff8&scoped=true&ts=true"
import script from "./GuidedScreener.vue?vue&type=script&lang=ts"
export * from "./GuidedScreener.vue?vue&type=script&lang=ts"

import "./GuidedScreener.vue?vue&type=style&index=0&id=20bc8ff8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bc8ff8"]])

export default __exports__